



















import { defineComponent, computed } from '@vue/composition-api';
import Tab from '../../common/tab.vue';
import { biClick } from '@tencent/fit-bi-sdk';
import { useTabStore } from '@/store/tab';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'CouponTab',
  components: {
    Tab,
  },
  setup(prop, context) {
    const tabStore = useTabStore();
    const { currentTabKey, tabConfig } = storeToRefs(tabStore);
    const { setCurrentTabKey } = tabStore;

    const initialActiveTab = tabConfig.value?.[0]?.key;

    // 点击tab 分类并上报
    const onStatClickTab = (key) => {
      biClick('rewards.rewardsbtn_click', { ftab: key });
      onClickTab(key);
    };
    // 点击tab 分类
    const onClickTab = (key) => {
      setCurrentTabKey(key);
      context.emit('onClickTab', key);
    };
    // 是否有下一个tab
    const hasNextTab = computed(() => {
      const currentTabIndex = tabConfig.value.findIndex(item => item.key === currentTabKey.value);
      return currentTabIndex >= 0 && currentTabIndex < (tabConfig.value.length - 1);
    });
    // 跳转到下一个tab
    const goNextTab = () => {
      const currentTabIndex = tabConfig.value.findIndex(item => item.key === currentTabKey.value);
      if (!hasNextTab.value) return;
      const nextTab = tabConfig.value[currentTabIndex + 1];
      onClickTab(nextTab.key);
    };
    return {
      currentTabKey,
      tabConfig,
      initialActiveTab, // 初始激活tab
      onStatClickTab,
      onClickTab,
      hasNextTab,
      goNextTab,
    };
  },
});
